import Modal from 'src/components/Modal'
import * as S from './ModalSelectSupplierReceivementType.styles'
import { SupplierReceivementTypeEnum } from '../../SupplierTypes'

interface ModalSelectSupplierReceivementTypeProps {
  isShow: boolean
  setShow: React.Dispatch<React.SetStateAction<boolean>>
  setSupplierType: React.Dispatch<React.SetStateAction<SupplierReceivementTypeEnum>>
}

export const ModalSelectSupplierReceivementType = ({
  isShow,
  setShow,
  setSupplierType,
}: ModalSelectSupplierReceivementTypeProps) => {
  const handleSelectSupplierReceivementType = (supplierType: SupplierReceivementTypeEnum) => {
    setSupplierType(supplierType)
    setShow(false)
  }

  return (
    <Modal
      show={isShow}
      size='lg'
      title='Selecione o tipo de recebimento'
      closedButton={false}
      testId='modal-select-supplier-receivement-type-test-id'
      centered
      body={(
        <S.Container>
          <S.CustomButton
            title={SupplierReceivementTypeEnum.SUPPLIER}
            bgColor='blue'
            hoverColor='darkBlueHover'
            letterColor='white'
            onClick={() => handleSelectSupplierReceivementType(SupplierReceivementTypeEnum.SUPPLIER)}
            testId='button-select-type-supplier-test-id'
          />
          <S.CustomButton
            title={SupplierReceivementTypeEnum.EXTERNAL_BUYER}
            bgColor='confirm'
            hoverColor='confirmHover'
            letterColor='white'
            onClick={() => handleSelectSupplierReceivementType(SupplierReceivementTypeEnum.EXTERNAL_BUYER)}
            testId='button-select-type-external-buyer-test-id'
          />
          <S.CustomButton
            title={SupplierReceivementTypeEnum.TRANSFER}
            bgColor='confirm'
            hoverColor='confirmHover'
            letterColor='white'
            onClick={() => handleSelectSupplierReceivementType(SupplierReceivementTypeEnum.TRANSFER)}
            testId='button-select-type-transfer-test-id'
          />
        </S.Container>
      )}
    />
  )
}
